// if (!process.env.NODE_ENV || process.env.NODE_ENV !== "development") {

// }
const user =
  !process.env.NODE_ENV || process.env.NODE_ENV !== "development"
    ? []
    : [
        {
          type: "amr",
          value: "pwd",
        },
        {
          type: "sid",
          value: "83CE9FA3A9F8482D205F71938A80C400",
        },
        {
          type: "sub",
          value: "fd23a5c2-93ee-4f4a-8333-e99107dcc823",
        },
        {
          type: "auth_time",
          value: "1635258857",
        },
        {
          type: "idp",
          value: "local",
        },
        {
          type: "preferred_username",
          value: "aggadmin@appguard.us",
        },
        {
          type: "name",
          value: "AppGuard Group Admin",
        },
        {
          type: "given_name",
          value: "AppGuard Group",
        },
        {
          type: "family_name",
          value: "Admin",
        },
        {
          type: "SiteGuid",
          value: '["51a8b118_e50d_4aef_bc33_bb952fd87b3c"]',
        },
        {
          type: "CompanyGuid",
          value: '["70981566-adc3-4733-9aa9-05d7cb0e7be6"]',
        },
        {
          type: "GroupGuid",
          value:
            '["221457b1_8937_4a10_9081_93fdaa7ccf3e","27b790c8_46a3_41e2_8528_e7f0f87f89fb"]',
        },
        {
          type: "role",
          // value: "Group Administrator",
          value: "Global Admin",
          
        },
        {
          type: "email",
          value: "aggadmin@appguard.us",
        },
        {
          type: "uid",
          value: "fd23a5c2-93ee-4f4a-8333-e99107dcc823",
        },
      ];

export const state = {
  authenticated: false,
  user: user,
  company: {
    companyGuid: "",
    companyName: "",
    selected: false,
    agms: false,
  },
  partner: {},
  site: {},
  group: {},
  agmsSite: {},
  agmsGroup: {},
  agmsTemplate: {},
};
export type State = typeof state;
